import IVideoPlayer from '../../types/IVideoPlayer';

let lastCommentIdNavigatedTo: string;

const navigateToReview = (history: any, reviewId: string, versionNumber: number): void => {
   const url = createCanonicalReviewUrl(reviewId, versionNumber);
   history.replace(url);
};

const navigateToReviewComment = (history: any, reviewId: string, versionNumber: number, commentId: string): void => {
   lastCommentIdNavigatedTo = commentId;
   const url = createCanonicalReviewUrl(reviewId, versionNumber, commentId);
   history.replace(url);
};

const navigateToReviewOnTimeMismatch = (history: any, player: IVideoPlayer, reviewId: string, versionNumber: number, commentId: string, commentTime: number): void => {
   player.one('timeupdate', () => {
      if (lastCommentIdNavigatedTo !== commentId) {
         return;
      }

      if (player.getCurrentTime() !== commentTime) {
         navigateToReview(history, reviewId, versionNumber);
      } else {
         navigateToReviewOnTimeMismatch(history, player, reviewId, versionNumber, commentId, commentTime);
      }
   });
};

const createCanonicalReviewUrl = (reviewId: string, versionNumber: number, commentId?: string): string => {
   if (!reviewId || !versionNumber) {
      throw new Error('reviewId and versionNumber are both required');
   }

   let url = '/review/' + reviewId + '/v' + versionNumber;
   if (commentId) {
      url += '?commentid=' + commentId;
   }
   return url;
};

export default {
   navigateToReview,
   navigateToReviewComment,
   navigateToReviewOnTimeMismatch,
   createCanonicalReviewUrl
};
